export enum TermType {
	TYPE_FORM_OF_CARE_SUKL = 'sukl_forma_pece',
	TYPE_FIELD_OF_CARE_SUKL = 'sukl_obor_pece',
	INSURANCE_COMPANIES = 'insurance_companies',
}
